/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_SendInputs */

const en_feedback_send = /** @type {(inputs: Feedback_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send`)
};

const zh_hans1_feedback_send = /** @type {(inputs: Feedback_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送`)
};

const pt_br2_feedback_send = /** @type {(inputs: Feedback_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar`)
};

const es_feedback_send = /** @type {(inputs: Feedback_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar`)
};

const fr_feedback_send = /** @type {(inputs: Feedback_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer`)
};

const de_feedback_send = /** @type {(inputs: Feedback_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senden`)
};

const ru_feedback_send = /** @type {(inputs: Feedback_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправить`)
};

const it_feedback_send = /** @type {(inputs: Feedback_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invia`)
};

/**
* | output |
* | --- |
* | "Send" |
*
* @param {Feedback_SendInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const feedback_send = /** @type {((inputs?: Feedback_SendInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_SendInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_feedback_send(inputs)
	if (locale === "pt-BR") return pt_br2_feedback_send(inputs)
	if (locale === "es") return es_feedback_send(inputs)
	if (locale === "fr") return fr_feedback_send(inputs)
	if (locale === "de") return de_feedback_send(inputs)
	if (locale === "ru") return ru_feedback_send(inputs)
	if (locale === "it") return it_feedback_send(inputs)
	return en_feedback_send(inputs)
});